import useSWR from "swr";
import Auth from "../Auth";

const useUserCustomization = () => {
  const fetcher = (url) => Auth.fetchWithIdToken(url).then((data) => data.customization);

  const endpointURL = "/api/user-customization/get";
  const { data: customization, error, isLoading, isValidating, mutate } = useSWR(endpointURL, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    customization,
    refetch: mutate,
    error,
    isLoading,
    isValidating,
  };
};

export default useUserCustomization;
